<template>
	<div>
		<CRow class="mb-4">
			<CCol lg="12">
				<h4 class="m-0">
					{{ $t('message.select_branch') }}
				</h4>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="6" class="d-flex flex-column">
				<label>
					{{ $t('message.select_branches') }}*
				</label>
				<span class="typo-helper-text">
					{{ $t('message.select_1_or_more_branch_to_apply_rule_to') }}
				</span>
			</CCol>
			<CCol lg="6" class="text-right">
				<CButton
					v-if="!disabled"
					color="secondary"
					class="btn-new-user transparent"
					@click="$refs['modal-branch'].open()"
				>
					{{ $t('button.add_branch') }}
				</CButton>
			</CCol>
		</CRow>

		<CRow class="mt-2">
			<CCol>
				<div v-if="values.length">
					<ul class="items-preview-box">
						<li
							v-for="(branch, index) in values"
							:key="index"
							class="items-preview-tag typo-body-2"
						>
							{{ branch.nameTH }}
						</li>
					</ul>
					<p class="typo-label">
						{{ $t('message.selected_total', { value: values.length }) }}
					</p>
				</div>
				<BaseNoItemBanner
					v-else
					:text="$t('message.there_is_no_branch_for_this_rule')"
					class="empty-box"
				/>
			</CCol>
			<CCol
				v-if="isValid === false"
				lg="12"
				class="mt-1"
			>
				<div class="invalid-feedback d-block">
					{{ $t('message.branches_is_required') }}
				</div>
			</CCol>
		</CRow>
		<!-- Modal Branch -->
		<ModalBranch
			ref="modal-branch"
			:title="$t('message.select_branches')"
			:selected-branches="values"
			@onSubmit="handleSubmit"
		/>
		<!-- End Modal Branch -->
	</div>
</template>

<script>

export default {
	name: 'SelectBranch',

	props: {
		values: {
			type: Array,
			default: () => [],
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		temporary: {
			type: Array,
			default: () => [],
		},
		isValid: {
			type: Boolean,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		handleSubmit(selectedBranchIds = []) {
			this.$emit('onDone', selectedBranchIds);
		},
	},
};
</script>

<style lang="scss" scoped>
.empty-box {
	&.is-invalid {
		border: 1px solid $color-alert;
		border-radius: rem(4);
	}
}

.items-preview-box {
	overflow-y: auto;
	min-height: rem(60);
	max-height: rem(468);
	padding: rem(20) rem(16);
	border-radius: rem(4);
	border: solid 1px $color-gray-400;
	list-style: none;
}

.items-preview-tag {
	border-radius: rem(4);
	background-color: $color-gray-300;
	color: $color-black-90;
	display: inline-block;
	padding: 0 rem(6);
	margin-right: rem(12);
	margin-bottom: rem(12);
}
</style>